export const carouselInicio = [
   {
      "imagen" : "videos/DeclaraP.gif",
   },  
 
 
]